import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Switch,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { createDentalFinding, updateDentalFinding } from "api/dentalMaster";

const DentalFindingModal = ({ open, onClose, data }) => {
  const [name, setName] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [saving, setSaving] = useState(false);

  const isEdit = Boolean(data?._id);

  useEffect(() => {
    setName(data?.name ?? "");
    setIsActive(data?.isActive !== false);
  }, [data]);

  const handleSave = async () => {
    const trimmed = name.trim();
    if (!trimmed) {
      toast.error("Finding name is required");
      return;
    }

    setSaving(true);
    try {
      const payload = { name: trimmed, isActive };
      if (isEdit) await updateDentalFinding(data._id, payload);
      else await createDentalFinding(payload);

      toast.success(`Finding ${isEdit ? "updated" : "created"} successfully`);
      onClose("save");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Save failed!");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => onClose("close")} fullWidth maxWidth="xs">
      <DialogTitle>{isEdit ? "Edit Finding" : "Add Finding"}</DialogTitle>
      <DialogContent dividers>
        <TextField
          label="Finding Name"
          value={name}
          onChange={(event) => setName(event.target.value)}
          fullWidth
          required
          size="small"
          autoFocus
          placeholder="e.g. Dental Caries"
          onKeyDown={(event) => {
            if (event.key === "Enter") handleSave();
          }}
        />
        <FormControlLabel
          sx={{ mt: 1 }}
          control={
            <Switch
              checked={isActive}
              onChange={(event) => setIsActive(event.target.checked)}
            />
          }
          label="Active"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose("close")} disabled={saving}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={saving}
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {saving ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DentalFindingModal;
